import React from 'react';
import './OrderSuccess.css'
import logo from "../../Images/dlogo/deshilogo.png";
import orderImg from "../../Images/ordersuccess.png";

const OrderSuccess = () => {
    return (
        <div className="success-container">
            <img src={logo} alt="logo" className="logo" />

            <div className="card">
                
                <h2>✅ Your Order is Confirmed!</h2>
                <p>Thank you for shopping with <br /> Deshi Agro Foods</p>
            </div>
        </div>
    );
};

export default OrderSuccess;